<!-- Main Information Panel -->
<div class="panel panel-default" *ngIf="dashboardService.client">
  <div class="panel-heading">
    <h3 class="panel-title">
      {{ dashboardService.client.name }}
    </h3>
  </div>
  <!-- Data and Configuration Errors -->
  <div *ngIf="!dashboardService.client || !dashboardService.website" class="panel-body">
    <div class="bold error">
      <i class="glyphicon glyphicon-exclamation-sign"></i>
      No websites are configured for {{ dashboardService.client.name }} Dashboard.<br />
      Please contact <a href="mailto:contact@matrix.tools">Matrix Tools</a>.
    </div>
    <br />
    Thank you!
    <br />
    - Matrix Tools Staff -->
  </div>
  <div *ngIf="dashboardService.client && dashboardService.website" class="panel-body center">
    <div class="row">
      <div class="col-md-6">
        <span class="underline">Website</span>:
        <span *ngIf="dashboardService.website.icon">
          <img class="circle icon" src="{{ dashboardService.website.icon }}" /> |
        </span>
        <a *ngIf="dashboardService.website" target="_blank" href="{{ '//' + dashboardService.website.domain }}">
          {{ dashboardService.website.domain }}
        </a>
      </div>
      <div class="col-md-6">
        <span class="underline">Industry</span>:
        {{ dashboardService.client.industry }}
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-6">
        <span class="underline">Service Rep</span>:
        <a target="_blank" href="mailto:{{ dashboardService.client.serviceRep.email }}">{{ dashboardService.client.serviceRep.name }}</a>
      </div>
      <div class="col-md-6">
        <span class="underline">Services</span>:
        <span *ngFor="let softwareService of dashboardService.client.softwareServices">
          <span *ngIf="!softwareService.link">
            <!-- VIP Service -->
            <i class="glyphicon glyphicon-star"></i>
            {{ softwareService.name }}
          </span>
          <a *ngIf="softwareService.link" target="_blank" href="{{ softwareService.link }}">{{ softwareService.name }}</a>
          <!-- //jeb possibly show any text message FROM numbers here? 
            it should say text message here for their service and we could add # somewhere Remove comment after text msg dashboard -->
          <br />
        </span>
      </div>
    </div>
    <div class="bottom row">
      <div class="col-md-6">
        <span class="underline">Renewal Date</span>:
        <span [class.error]="dashboardService.client.isSoftwareServiceRenewalDue"
              [class.warning]="dashboardService.client.isSoftwareServiceRenewalSoon"
              [class.green-text]="!dashboardService.client.isSoftwareServiceRenewalDue && !dashboardService.client.isSoftwareServiceRenewalSoon">
          <i class="glyphicon glyphicon-time"></i>
          {{ dashboardService.client.softwareServiceRenewalDate | date:'mediumDate' }}
          <br />
          <a class="button" target="_blank" href="/digital-marketing#!/Services/c/71207693">Renew Now</a>
        </span>
      </div>
      <div class="col-md-6">
        <span class="underline">Last Website Update</span>:
        {{ dashboardService.website.commitHistory[0].commit.author.date | date:'mediumDate' }}
      </div>
    </div>
    </div>
</div>
